export default "/images/vendor/flag-icon-css/flags/4x3/bl.svg?ee0d8635f3377e52c7f398e291d7a280";